module.exports = __webpack_public_path__ + "media/mine-video.c948af95.mp4";